__turbopack_context__.v({
  "closeButton": "i-f5CW_closeButton",
  "hotSpotInfo": "i-f5CW_hotSpotInfo",
  "hotSpotTitle": "i-f5CW_hotSpotTitle",
  "hotspot": "i-f5CW_hotspot",
  "hotspotSection": "i-f5CW_hotspotSection",
  "hotspotViewer": "i-f5CW_hotspotViewer",
  "image": "i-f5CW_image",
  "imageWrapper": "i-f5CW_imageWrapper",
  "wrapper": "i-f5CW_wrapper",
});
